import { connect } from 'react-redux';

import MasterDataComponent from '../../components/masterData/MasterData';

const MasterData = connect()(MasterDataComponent);

export default MasterData;
